export enum RoutingPaths {
  scb = "scb",

  myhealth = "myhealth",
  myhome = "myhome",
  remote = "remote",

  apk = "apk",
  variants = "variants",
  insuranceData = "insurance-data",
  payment = "payment",
  createPolicy = "createPolicy",

  status = "status",
  invalid = "invalid",

  otp = "otp",
  policyData = "policy-data"

}
